import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import LanguageDriverTable from 'components/languageDriver/LanguageDriverTable';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useEffect, useContext } from 'react';
import LanguageDriverServices from 'services/LanguageDriverServices';
import sidebar from 'routes/sidebar';
import LanguageDriverDrawer from 'components/drawer/LanguageDriverDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import { SidebarContext } from 'context/SidebarContext';
import { FiPlus } from 'react-icons/fi';
import DataWrapper from './DataWrapper';
import { FiRefreshCcw } from 'react-icons/fi';

const LanguageDriver = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { data, loading, error } = useAsync(
		LanguageDriverServices.getAllLanguageDriver
	);
	//const languagedriver = data?.data || [];
	// const [loading, setLoading] = useState(false);
	const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
	const { title, serviceId } = useToggleDrawer();
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [languagedriverData, setLanguageDriverData] = useState([]);
	const [status, setStatus] = useState('');

	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'driver language' && perm.view === 1
		  );

	const hideDelete = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'driver language' && perm.delete === 1
		  );

	const hideEdit = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'driver language' && perm.edit === 1
		  );

	const hideAdd = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'driver language' && perm.add === 1
		  );

	useEffect(() => {
		if (data?.status) {
			setStatus(data.status);
		} else {
			setStatus(false);
		}
	}, [data?.status]);

	const {
		languagedriverRef,
		dataTable,
		serviceData,
		handleSubmitLanguageDriver,
		currentPage,
	} = useFilter(languagedriverData, itemsPerPage);

	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	useEffect(() => {
		if (data) {
			const responseData = data?.data || [];
			if (Array.isArray(responseData)) {
				const updatedData = responseData.map(
					({ id, lang_driver, ...rest }) => ({
						id,
						lang_driver,

						...rest,
					})
				);
				setLanguageDriverData(updatedData);
			} else {
				console.error('Expected an array but got:', responseData);
			}
		} else {
			console.error('Data is null or undefined');
		}
	}, [data]);

	const handleRefresh = () => {
		setIsUpdate(true);
	};
	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />
					<MainDrawer>
						<LanguageDriverDrawer id={serviceId} />
					</MainDrawer>
					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div className="flex gap-6 items-center">
								<div style={{ width: '600px' }}>
									<Input
										ref={languagedriverRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										autoComplete="off"
										placeholder="Quick Search"
										onChange={handleSubmitLanguageDriver}
									/>
								</div>

								{hideAdd && (
									<Button
										onClick={toggleDrawer}
										className="w-56 rounded-md h-10"
									>
										<span className="mr-3">
											<FiPlus />
										</span>
										Add Driver Language
									</Button>
								)}

								<FiRefreshCcw
									onClick={() => {
										handleRefresh();
									}}
									cursor="pointer"
								/>
							</div>
						</CardBody>
					</Card>

					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<TableContainer
								className="mb-8"
								style={{
									maxHeight: '65vh',
									overflowY: 'scroll',
									scrollbarWidth: 'thin',
								}}
							>
								<Table>
									<TableHeader className="custom-table-header capitalize sticky top-0 z-10">
										<tr>
											<TableCell className="text-center">Sl.No.</TableCell>
											<TableCell className="text-center">Language</TableCell>
											{(hideEdit||hideDelete)&&(
											<TableCell className="text-center">Actions</TableCell>

											)}
										</tr>
									</TableHeader>

									<LanguageDriverTable
										languagedriver={dataTable}
										perpage={itemsPerPage}
										currentPage={currentPage}
										hideEdit={hideEdit}
										hideDelete={hideDelete}
									/>
								</Table>
							</TableContainer>
						) : (
							<NotFound title="There are no languagedrivers." />
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default LanguageDriver;
